export const languageData = {
  id: {
    // Navigation
    home: "Home",
    services: "Layanan",
    products: "Produk",
    team: "Tim & Sejarah",
    contact: "Kontak",
    "contact-us": "Hubungi Kami",

    // Hero Section
    "hero-title": "Solusi <span>IT</span> Terbaik untuk Bisnis Anda",
    "hero-desc":
      "Facioware menghadirkan layanan pengembangan web, mobile, dan managed IT terpercaya untuk mendukung transformasi digital perusahaan Anda. Dilengkapi dengan produk SaaS distribusi dan klinik yang inovatif.",
    "learn-more": "Pelajari Lebih Lanjut",
    feature1: "Konsultasi gratis untuk kebutuhan IT Anda",
    feature2: "Demo produk SaaS tanpa biaya",

    // Services Section
    "services-title": "Layanan Kami",
    "services-desc":
      "Kami menyediakan solusi IT komprehensif untuk membantu bisnis Anda berkembang di era digital",
    "service1-title": "Website Development",
    "service1-desc":
      "Pembuatan website profesional untuk bisnis Anda, mulai dari company profile hingga e-commerce dengan desain responsif dan SEO friendly.",
    "service2-title": "Web Application",
    "service2-desc":
      "Pengembangan aplikasi web custom sesuai kebutuhan bisnis Anda dengan teknologi terkini dan performa optimal.",
    "service3-title": "Mobile Application",
    "service3-desc":
      "Pembuatan aplikasi mobile untuk platform iOS dan Android dengan user experience yang menarik dan intuitif.",
    "service4-title": "IT Managed Care",
    "service4-desc":
      "Layanan manajemen infrastruktur IT secara menyeluruh untuk memastikan operasional bisnis berjalan lancar.",
    "view-details": "Klik untuk detail",

    // Products Section
    "products-title": "Produk SaaS Kami",
    "products-desc":
      "Solusi software-as-a-service inovatif yang dirancang khusus untuk industri distribusi dan kesehatan",
    "saas-tag": "SaaS Solution",
    "product1-title": "SaaS Distribusi",
    "product1-desc":
      "Platform manajemen distribusi yang terintegrasi untuk mengoptimalkan rantai pasok, inventaris, dan logistik bisnis Anda. Lacak pengiriman real-time dan kelola pemasok dengan mudah.",
    "product2-title": "SaaS Klinik",
    "product2-desc":
      "Sistem manajemen klinik dan praktik dokter yang lengkap untuk meningkatkan efisiensi pelayanan kesehatan. Kelola janji temu, rekam medis, dan inventaris obat dengan satu platform.",

    // Team & History Section
    "team-title": "Tim & Sejarah Kami",
    "team-desc":
      "Kenali tim profesional di balik Facioware dan perjalanan perusahaan kami",
    "our-team": "Tim Profesional Kami",
    "role-ceo": "CEO & Founder",
    "ceo-desc":
      "Memiliki pengalaman 10+ tahun di industri teknologi dan startup.",
    "role-cto": "CTO",
    "cto-desc":
      "Spesialis dalam arsitektur sistem dan pengembangan perangkat lunak.",
    "role-product": "Head of Product",
    "product-desc": "Bertanggung jawab atas pengembangan produk SaaS kami.",
    "role-dev": "Lead Developer",
    "dev-desc": "Memimpin tim pengembangan aplikasi web dan mobile.",
    "history-title": "Sejarah Facioware",
    "history-desc1":
      'Facioware didirikan pada tahun 2018 dengan visi untuk menyediakan solusi IT yang mudah diakses dan terjangkau bagi UMKM di Indonesia. Nama "Facioware" diambil dari bahasa Arab yang berarti "fondasi", mencerminkan komitmen kami dalam membangun fondasi digital yang kokoh untuk bisnis klien kami.',
    "history-desc2":
      "Dari tim kecil yang hanya terdiri dari 3 orang, kami telah berkembang menjadi perusahaan dengan lebih dari 30 profesional IT yang berdedikasi. Fokus utama kami adalah pada pengembangan solusi SaaS yang spesifik untuk industri distribusi dan kesehatan, dua sektor yang menjadi tulang punggung perekonomian Indonesia.",
    "highlight1-title": "Pertumbuhan Cepat",
    "highlight1-desc": "Melayani 100+ klien dalam 3 tahun pertama operasi.",
    "highlight2-title": "Penghargaan",
    "highlight2-desc":
      "Startup Teknologi Terbaik 2022 oleh Kementerian Komunikasi dan Informatika.",
    "highlight3-title": "Tim Berkualitas",
    "highlight3-desc":
      "Lebih dari 30 profesional IT dengan berbagai spesialisasi.",
    "highlight4-title": "Ekspansi",
    "highlight4-desc":
      "Berkembang ke 5 kota besar di Indonesia dalam waktu 4 tahun.",
    "vision-mission": "Visi & Misi",
    "vision-label": "Visi:",
    "vision-text":
      "Menjadi mitra digital terdepan untuk transformasi bisnis di Indonesia.",
    "mission-label": "Misi:",
    "mission-text":
      "Menyediakan solusi IT yang inovatif, terjangkau, dan berdampak positif bagi pertumbuhan bisnis klien.",

    // Footer
    "footer-desc":
      "Facioware adalah startup IT yang berfokus pada pengembangan aplikasi web, mobile, layanan IT managed care, serta produk SaaS untuk industri distribusi dan kesehatan.",
    "services-label": "Layanan",
    "contact-label": "Kontak Kami",
    address: "Jl. Teknologi No. 123, Jakarta",
    phone: "(021) 1234-5678",
    email: "info@Facioware.id",
    hours: "Senin - Jumat: 9:00 - 17:00",
    copyright:
      '<i class="far fa-copyright"></i> 2024 Facioware IT Solutions. Semua hak dilindungi.',

    // Modal Content
    "modal-website-title": "Website Development",
    "modal-website-desc":
      "Kami membuat website profesional untuk bisnis Anda yang tidak hanya menarik secara visual tetapi juga fungsional, responsif, dan SEO friendly. Mulai dari website company profile hingga e-commerce dengan fitur lengkap untuk membantu bisnis Anda berkembang di dunia digital.",
    "modal-webapp-title": "Web Application Development",
    "modal-webapp-desc":
      "Kami mengembangkan aplikasi web yang sesuai dengan kebutuhan spesifik bisnis Anda. Dengan teknologi terkini seperti React, Vue.js, Node.js, dan Laravel, kami memastikan aplikasi web Anda memiliki performa optimal, keamanan terjamin, dan pengalaman pengguna yang luar biasa.",
    "modal-mobile-title": "Mobile Application Development",
    "modal-mobile-desc":
      "Kami membuat aplikasi mobile untuk platform iOS dan Android yang memberikan pengalaman pengguna yang menarik dan intuitif. Aplikasi kami dirancang untuk meningkatkan engagement dan mendukung operasional bisnis Anda.",
    "modal-it-title": "IT Managed Care Services",
    "modal-it-desc":
      "Layanan manajemen infrastruktur IT secara menyeluruh untuk memastikan operasional bisnis Anda berjalan lancar. Kami menangani semua kebutuhan IT Anda sehingga Anda bisa fokus pada core business. Layanan kami mencakup monitoring 24/7, backup data, keamanan jaringan, dan dukungan teknis.",
    "modal-features": "Fitur Utama:",
    "modal-packages": "Paket Layanan:",
    "modal-details": "Informasi Detail:",
    "modal-timeline": "Timeline Pengerjaan:",
    "modal-pricing": "Estimasi Biaya:",
    "modal-whatsapp": "Hubungi via WhatsApp",
    "modal-trial-btn": "Coba Free Trial",
    "modal-demo-btn": "Jadwalkan Demo",
    "modal-saas-features": "Fitur Lengkap:",
    "modal-benefits": "Manfaat untuk Bisnis Anda:",
    "modal-subscription": "Harga Berlangganan:",
    "modal-free-trial": "Free Trial:",
    "modal-start-using": "Mulai Menggunakan",

    // Package Names
    "package-basic": "Basic Website",
    "package-business": "Business Website",
    "package-ecommerce": "E-commerce Website",
    "package-basic-features": "5 halaman, desain responsif, SEO basic",
    "package-business-features": "10 halaman, desain custom, SEO advanced",
    "package-ecommerce-features":
      "Full e-commerce, payment gateway, inventory system",
  },
  en: {
    // Navigation
    home: "Home",
    services: "Services",
    products: "Products",
    team: "Team & History",
    contact: "Contact",
    "contact-us": "Contact Us",

    // Hero Section
    "hero-title": "Best <span>IT</span> Solutions for Your Business",
    "hero-desc":
      "Facioware provides reliable web, mobile, and managed IT development services to support your company's digital transformation. Equipped with innovative distribution and clinic SaaS products.",
    "learn-more": "Learn More",
    feature1: "Free consultation for your IT needs",
    feature2: "SaaS product demo at no cost",

    // Services Section
    "services-title": "Our Services",
    "services-desc":
      "We provide comprehensive IT solutions to help your business thrive in the digital era",
    "service1-title": "Website Development",
    "service1-desc":
      "Professional website creation for your business, from company profile to e-commerce with responsive design and SEO friendly.",
    "service2-title": "Web Application",
    "service2-desc":
      "Custom web application development according to your business needs with the latest technology and optimal performance.",
    "service3-title": "Mobile Application",
    "service3-desc":
      "Mobile app development for iOS and Android platforms with engaging and intuitive user experience.",
    "service4-title": "IT Managed Care",
    "service4-desc":
      "Comprehensive IT infrastructure management services to ensure your business operations run smoothly.",
    "view-details": "Click for details",

    // Products Section
    "products-title": "Our SaaS Products",
    "products-desc":
      "Innovative software-as-a-service solutions specifically designed for distribution and healthcare industries",
    "saas-tag": "SaaS Solution",
    "product1-title": "SaaS Distribution",
    "product1-desc":
      "Integrated distribution management platform to optimize your business supply chain, inventory, and logistics. Track shipments in real-time and manage suppliers easily.",
    "product2-title": "SaaS Clinic",
    "product2-desc":
      "Complete clinic and medical practice management system to increase healthcare service efficiency. Manage appointments, medical records, and drug inventory with one platform.",

    // Team & History Section
    "team-title": "Our Team & History",
    "team-desc":
      "Get to know the professional team behind Facioware and our company journey",
    "our-team": "Our Professional Team",
    "role-ceo": "CEO & Founder",
    "ceo-desc":
      "Has 10+ years of experience in technology industry and startups.",
    "role-cto": "CTO",
    "cto-desc": "Specializes in system architecture and software development.",
    "role-product": "Head of Product",
    "product-desc": "Responsible for the development of our SaaS products.",
    "role-dev": "Lead Developer",
    "dev-desc": "Leads web and mobile application development team.",
    "history-title": "Facioware History",
    "history-desc1":
      'Facioware was founded in 2018 with the vision to provide easily accessible and affordable IT solutions for SMEs in Indonesia. The name "Facioware" is taken from Arabic which means "foundation", reflecting our commitment to building a strong digital foundation for our clients\' businesses.',
    "history-desc2":
      "From a small team of only 3 people, we have grown into a company with more than 30 dedicated IT professionals. Our main focus is on developing SaaS solutions specific to the distribution and healthcare industries, two sectors that are the backbone of the Indonesian economy.",
    "highlight1-title": "Rapid Growth",
    "highlight1-desc": "Served 100+ clients in the first 3 years of operation.",
    "highlight2-title": "Awards",
    "highlight2-desc":
      "Best Technology Startup 2022 by Ministry of Communication and Information Technology.",
    "highlight3-title": "Qualified Team",
    "highlight3-desc":
      "More than 30 IT professionals with various specializations.",
    "highlight4-title": "Expansion",
    "highlight4-desc":
      "Expanded to 5 major cities in Indonesia within 4 years.",
    "vision-mission": "Vision & Mission",
    "vision-label": "Vision:",
    "vision-text":
      "To become the leading digital partner for business transformation in Indonesia.",
    "mission-label": "Mission:",
    "mission-text":
      "To provide innovative, affordable, and positively impactful IT solutions for client business growth.",

    // Footer
    "footer-desc":
      "Facioware is an IT startup focused on web application development, mobile, IT managed care services, as well as SaaS products for the distribution and healthcare industries.",
    "services-label": "Services",
    "contact-label": "Contact Us",
    address: "Jl. Teknologi No. 123, Jakarta",
    phone: "(021) 1234-5678",
    email: "info@Facioware.id",
    hours: "Monday - Friday: 9:00 AM - 5:00 PM",
    copyright:
      '<i class="far fa-copyright"></i> 2024 Facioware IT Solutions. All rights reserved.',

    // Modal Content
    "modal-website-title": "Website Development",
    "modal-website-desc":
      "We create professional websites for your business that are not only visually appealing but also functional, responsive, and SEO friendly. From company profile websites to full-featured e-commerce with complete functionality to help your business thrive in the digital world.",
    "modal-webapp-title": "Web Application Development",
    "modal-webapp-desc":
      "We develop web applications that match your specific business needs. With the latest technology like React, Vue.js, Node.js, and Laravel, we ensure your web application has optimal performance, guaranteed security, and exceptional user experience.",
    "modal-mobile-title": "Mobile Application Development",
    "modal-mobile-desc":
      "We create mobile applications for iOS and Android platforms that deliver engaging and intuitive user experiences. Our apps are designed to increase engagement and support your business operations.",
    "modal-it-title": "IT Managed Care Services",
    "modal-it-desc":
      "Comprehensive IT infrastructure management services to ensure your business operations run smoothly. We handle all your IT needs so you can focus on your core business. Our services include 24/7 monitoring, data backup, network security, and technical support.",
    "modal-features": "Main Features:",
    "modal-packages": "Service Packages:",
    "modal-details": "Detail Information:",
    "modal-timeline": "Project Timeline:",
    "modal-pricing": "Estimated Cost:",
    "modal-whatsapp": "Contact via WhatsApp",
    "modal-trial-btn": "Try Free Trial",
    "modal-demo-btn": "Schedule Demo",
    "modal-saas-features": "Complete Features:",
    "modal-benefits": "Benefits for Your Business:",
    "modal-subscription": "Subscription Price:",
    "modal-free-trial": "Free Trial:",
    "modal-start-using": "Start Using",

    // Package Names
    "package-basic": "Basic Website",
    "package-business": "Business Website",
    "package-ecommerce": "E-commerce Website",
    "package-basic-features": "5 pages, responsive design, basic SEO",
    "package-business-features": "10 pages, custom design, advanced SEO",
    "package-ecommerce-features":
      "Full e-commerce, payment gateway, inventory system",
  },
};

export const servicesData = {
  "website-dev": {
    title: "modal-website-title",
    icon: "fas fa-globe",
    description: "modal-website-desc",
    features: [
      {
        id: "Website company profile profesional",
        en: "Professional company profile website",
      },
      {
        id: "E-commerce dengan sistem pembayaran lengkap",
        en: "E-commerce with complete payment system",
      },
      {
        id: "Desain responsif untuk semua perangkat",
        en: "Responsive design for all devices",
      },
      {
        id: "Optimasi SEO untuk peringkat Google",
        en: "SEO optimization for Google ranking",
      },
      {
        id: "Integrasi media sosial dan analytics",
        en: "Social media and analytics integration",
      },
      {
        id: "CMS (Content Management System) mudah digunakan",
        en: "Easy-to-use CMS (Content Management System)",
      },
      {
        id: "Keamanan website dan SSL certificate",
        en: "Website security and SSL certificate",
      },
      {
        id: "Maintenance dan update berkala",
        en: "Regular maintenance and updates",
      },
    ],
    packages: [
      {
        name: "package-basic",
        price: "Rp 5.000.000",
        features: "package-basic-features",
      },
      {
        name: "package-business",
        price: "Rp 10.000.000",
        features: "package-business-features",
      },
      {
        name: "package-ecommerce",
        price: "Rp 25.000.000",
        features: "package-ecommerce-features",
      },
    ],
    timeline: {
      id: "2-6 minggu tergantung kompleksitas",
      en: "2-6 weeks depending on complexity",
    },
  },
  "web-app": {
    title: "modal-webapp-title",
    icon: "fas fa-laptop-code",
    description: "modal-webapp-desc",
    features: [
      {
        id: "Pengembangan aplikasi web custom sesuai kebutuhan bisnis",
        en: "Custom web application development according to business needs",
      },
      {
        id: "Teknologi modern: React, Vue.js, Node.js, Laravel",
        en: "Modern technology: React, Vue.js, Node.js, Laravel",
      },
      {
        id: "Responsive design untuk semua perangkat",
        en: "Responsive design for all devices",
      },
      {
        id: "Integrasi dengan API dan sistem pihak ketiga",
        en: "Integration with APIs and third-party systems",
      },
      {
        id: "Keamanan data dan proteksi dari serangan cyber",
        en: "Data security and protection from cyber attacks",
      },
      {
        id: "Optimasi performa dan kecepatan loading",
        en: "Performance optimization and loading speed",
      },
      {
        id: "Maintenance dan dukungan teknis berkelanjutan",
        en: "Ongoing maintenance and technical support",
      },
    ],
    pricing: {
      id: "Mulai dari Rp 15.000.000 - Tergantung kompleksitas",
      en: "Starting from Rp 15,000,000 - Depending on complexity",
    },
    timeline: {
      id: "4-12 minggu tergantung scope proyek",
      en: "4-12 weeks depending on project scope",
    },
  },
  "mobile-app": {
    title: "modal-mobile-title",
    icon: "fas fa-mobile-alt",
    description: "modal-mobile-desc",
    features: [
      {
        id: "Pengembangan aplikasi native iOS (Swift) dan Android (Kotlin)",
        en: "Native iOS (Swift) and Android (Kotlin) application development",
      },
      {
        id: "Pengembangan aplikasi cross-platform (React Native, Flutter)",
        en: "Cross-platform application development (React Native, Flutter)",
      },
      {
        id: "UI/UX design yang menarik dan intuitif",
        en: "Engaging and intuitive UI/UX design",
      },
      {
        id: "Integrasi dengan backend dan API",
        en: "Integration with backend and APIs",
      },
      {
        id: "Push notification dan fitur offline",
        en: "Push notifications and offline features",
      },
      {
        id: "Publish ke App Store dan Google Play Store",
        en: "Publish to App Store and Google Play Store",
      },
      {
        id: "Testing dan quality assurance menyeluruh",
        en: "Comprehensive testing and quality assurance",
      },
    ],
    pricing: {
      id: "Mulai dari Rp 25.000.000 - Tergantung platform dan fitur",
      en: "Starting from Rp 25,000,000 - Depending on platform and features",
    },
    timeline: {
      id: "8-16 minggu tergantung kompleksitas",
      en: "8-16 weeks depending on complexity",
    },
  },
  "it-managed": {
    title: "modal-it-title",
    icon: "fas fa-server",
    description: "modal-it-desc",
    features: [
      {
        id: "Manajemen server dan jaringan 24/7",
        en: "24/7 server and network management",
      },
      {
        id: "Monitoring sistem dan performa real-time",
        en: "Real-time system and performance monitoring",
      },
      {
        id: "Backup dan disaster recovery planning",
        en: "Backup and disaster recovery planning",
      },
      { id: "Keamanan jaringan dan sistem", en: "Network and system security" },
      {
        id: "Helpdesk support untuk karyawan",
        en: "Helpdesk support for employees",
      },
      {
        id: "Manajemen software license dan update",
        en: "Software license management and updates",
      },
      {
        id: "Cloud migration dan optimization",
        en: "Cloud migration and optimization",
      },
      {
        id: "Consulting dan IT strategy planning",
        en: "Consulting and IT strategy planning",
      },
    ],
    pricing: {
      id: "Mulai dari Rp 5.000.000/bulan - Tergantung scope",
      en: "Starting from Rp 5,000,000/month - Depending on scope",
    },
    timeline: {
      id: "Setup awal 2-4 minggu, lalu ongoing support",
      en: "Initial setup 2-4 weeks, then ongoing support",
    },
  },
};

export const productsData = {
  "saas-distribusi": {
    title: {
      id: "SaaS Distribusi - Supply Chain Management",
      en: "SaaS Distribution - Supply Chain Management",
    },
    icon: "fas fa-truck-loading",
    description: {
      id: "Platform manajemen distribusi yang terintegrasi untuk mengoptimalkan rantai pasok, inventaris, dan logistik bisnis Anda. Sistem ini dirancang khusus untuk perusahaan distribusi dengan fitur lengkap untuk meningkatkan efisiensi operasional.",
      en: "Integrated distribution management platform to optimize your business supply chain, inventory, and logistics. This system is specifically designed for distribution companies with complete features to increase operational efficiency.",
    },
    features: [
      {
        id: "Manajemen inventaris real-time",
        en: "Real-time inventory management",
      },
      {
        id: "Tracking pengiriman dan logistik",
        en: "Shipment and logistics tracking",
      },
      {
        id: "Management pemasok dan vendor",
        en: "Supplier and vendor management",
      },
      {
        id: "Analytics dan reporting dashboard",
        en: "Analytics and reporting dashboard",
      },
      {
        id: "Integrasi dengan sistem akuntansi",
        en: "Integration with accounting systems",
      },
      {
        id: "Mobile app untuk sales dan driver",
        en: "Mobile app for sales and drivers",
      },
      {
        id: "Forecasting dan planning tools",
        en: "Forecasting and planning tools",
      },
      { id: "Multi-warehouse management", en: "Multi-warehouse management" },
    ],
    benefits: [
      {
        id: "Meningkatkan efisiensi operasional hingga 40%",
        en: "Increase operational efficiency up to 40%",
      },
      {
        id: "Mengurangi kesalahan inventory hingga 90%",
        en: "Reduce inventory errors up to 90%",
      },
      {
        id: "Mempercepat proses pengiriman",
        en: "Accelerate delivery process",
      },
      { id: "Mengoptimalkan biaya logistik", en: "Optimize logistics costs" },
      {
        id: "Meningkatkan kepuasan pelanggan",
        en: "Increase customer satisfaction",
      },
    ],
    pricing: {
      id: "Rp 1.500.000 - 5.000.000/bulan tergantung jumlah user",
      en: "Rp 1,500,000 - 5,000,000/month depending on number of users",
    },
    trial: {
      id: "Free trial 14 hari tersedia",
      en: "14-day free trial available",
    },
  },
  "saas-klinik": {
    title: {
      id: "SaaS Klinik - Healthcare Management System",
      en: "SaaS Clinic - Healthcare Management System",
    },
    icon: "fas fa-clinic-medical",
    description: {
      id: "Sistem manajemen klinik dan praktik dokter yang lengkap untuk meningkatkan efisiensi pelayanan kesehatan. Platform ini membantu Anda mengelola semua aspek operasional klinik secara terintegrasi.",
      en: "Complete clinic and medical practice management system to increase healthcare service efficiency. This platform helps you manage all aspects of clinic operations in an integrated way.",
    },
    features: [
      {
        id: "Electronic Medical Records (EMR)",
        en: "Electronic Medical Records (EMR)",
      },
      {
        id: "Appointment scheduling online",
        en: "Online appointment scheduling",
      },
      {
        id: "Billing dan payment processing",
        en: "Billing and payment processing",
      },
      {
        id: "Pharmacy dan inventory management",
        en: "Pharmacy and inventory management",
      },
      { id: "Laboratory integration", en: "Laboratory integration" },
      { id: "Telemedicine capabilities", en: "Telemedicine capabilities" },
      {
        id: "Reporting dan analytics dashboard",
        en: "Reporting and analytics dashboard",
      },
      { id: "HIPAA compliant security", en: "HIPAA compliant security" },
    ],
    benefits: [
      {
        id: "Mengurangi waktu administrasi hingga 60%",
        en: "Reduce administrative time up to 60%",
      },
      {
        id: "Meningkatkan kapasitas pasien yang dilayani",
        en: "Increase patient capacity served",
      },
      { id: "Meminimalkan kesalahan medis", en: "Minimize medical errors" },
      {
        id: "Meningkatkan kepuasan pasien",
        en: "Increase patient satisfaction",
      },
      {
        id: "Data terpusat dan mudah diakses",
        en: "Centralized and easily accessible data",
      },
    ],
    pricing: {
      id: "Rp 2.000.000 - 6.000.000/bulan tergantung fitur",
      en: "Rp 2,000,000 - 6,000,000/month depending on features",
    },
    trial: {
      id: "Free trial 30 hari tersedia",
      en: "30-day free trial available",
    },
  },
};
